import { useEffect, useState } from "react";
import { SplitWheel } from "./SplitWheel";

const DEMO_MEMBERS = [
    { id: "auth-a", name: "Alex", role_label: "Lead", percentage: 40, color: "#00BF0D", status: "active" },
    { id: "auth-b", name: "Jordan", role_label: "Developer", percentage: 35, color: "#009FBF", status: "active" },
    { id: "auth-c", name: "Sam", role_label: "Design", percentage: 25, color: "#941FD9", status: "active" },
];

/** Decorative split wheel for auth marketing — flat, centered, slow float. */
export function AuthWheelShowcase({ compact = false, className = "" }) {
    const [highlightId, setHighlightId] = useState(DEMO_MEMBERS[0].id);
    const size = compact ? 196 : 280;
    const stroke = compact ? 6.5 : 11;
    const glowBleed = compact ? 22 : 14;
    const outerSize = size + glowBleed * 2;

    useEffect(() => {
        let idx = 0;
        const timer = setInterval(() => {
            idx = (idx + 1) % DEMO_MEMBERS.length;
            setHighlightId(DEMO_MEMBERS[idx].id);
        }, 3200);
        return () => clearInterval(timer);
    }, []);

    return (
        <div
            className={`auth-wheel-showcase ${compact ? "auth-wheel-showcase--compact" : ""} ${className}`.trim()}
            style={{ "--auth-wheel-outer": `${outerSize}px` }}
            aria-hidden
            data-testid="auth-wheel-showcase"
        >
            <div className="auth-wheel-showcase__frame">
                <div className="auth-wheel-showcase__float">
                    <SplitWheel
                        members={DEMO_MEMBERS}
                        size={size}
                        stroke={stroke}
                        highlightId={highlightId}
                        glowBleed={glowBleed}
                        ariaLabel="FairShare profit split preview"
                    />
                </div>
            </div>
        </div>
    );
}
